import { FormattedMessage } from 'react-intl'
import { OPERATION_TYPES } from 'src/constants/queries'
import Popover from '@components/Popover/Popover'
import type { BlueprintNode, OperationType } from 'src/types/queries'

interface OperationPickerProps {
  blueprint: BlueprintNode[]
  nodeToWrap: BlueprintNode | null
  selectedType: OperationType | null
  onSelectType: (type: OperationType) => void
  onContinue: () => void
}

export default function OperationPicker({
  blueprint,
  nodeToWrap,
  selectedType,
  onSelectType,
  onContinue
}: OperationPickerProps) {
  const currentIdx = blueprint.findIndex((n) => n.nodeId === nodeToWrap?.nodeId)
  const hasRightNeighbor =
    currentIdx !== -1 && currentIdx + 1 < blueprint.length

  const isDisabled = (type: OperationType): boolean =>
    type === 'join' && !hasRightNeighbor

  return (
    <div id="operation-editor">
      <ul className="operation-options">
        {OPERATION_TYPES.map((type) => {
          const disabled = isDisabled(type)
          return (
            <li key={type} className={disabled ? 'disabled-option' : ''}>
              <Popover
                position="bottom"
                triggerContent={<span className="icon icon-info" />}
              >
                <FormattedMessage id={`operation-editor.description.${type}`} />
              </Popover>
              <label
                className={`operation-option ${selectedType === type ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                data-type={type}
              >
                <input
                  type="radio"
                  name="operation-type"
                  value={type}
                  checked={selectedType === type}
                  disabled={disabled}
                  onChange={() => onSelectType(type)}
                />
                <FormattedMessage id={`operation-editor.option.${type}`} />
              </label>
            </li>
          )
        })}
      </ul>
      <button
        className="cta-button"
        onClick={onContinue}
        disabled={selectedType === null}
      >
        <FormattedMessage id="node-editor.button.continue" />
      </button>
    </div>
  )
}
